export enum FieldDefinitions {
  ordersI = 'ordersI',
  salesI = 'salesI',
  cpoI = 'cpoI',
  roasI = 'roasI',
  mediaSpend = 'mediaSpend',
  previousOrdersI = 'previousOrdersI',
  previousSalesI = 'previousSalesI',
  currentOrdersI = 'currentOrdersI',
  currentSalesI = 'currentSalesI',
  proratedCurOrdersI = 'proratedCurOrdersI',
  proratedCurCpoI = 'proratedCurCpoI',
  proratedCurSalesI = 'proratedCurSalesI',
  proratedCurRoasI = 'proratedCurRoasI',
  changeInPercent = 'changeInPercent'
}
